import { Injectable } from '@angular/core';

declare let dataLayer: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsEventsService {

  public emitEvent(eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {

    dataLayer.push({
      'event': 'eventTracker',
      'eventCat': eventCategory,
      'eventAct': eventAction,
      'eventLbl': eventLabel
    });
  }
}
